import TagSelector from "@pathwright/ui/src/components/tag/selector/TagSelector"
import PropTypes from "prop-types"
import { useTagManagerCard } from "./TagManagerContainer"
import TagManagerPrompt from "./TagManagerPrompt"
import { tagAttachmentContextPropType } from "./propTypes"
import useTagPermissions from "./useTagPermissions"

const TagSelectorWithTagManager = ({
  tags,
  context,
  useContextLabels,
  CustomTagManager,
  onSelectTags,
  ...passProps
}) => {
  const { tagManagerCardStack, openTagManagerCard } = useTagManagerCard({
    context,
    onSelectTags,
    useContextLabels,
    CustomTagManager,
    ...passProps
  })

  const { managePrompt, selectLabel, tagFormLabels } = useContextLabels(context)
  const tagPermissions = useTagPermissions({ context })

  const postMenuList =
    tagPermissions.canEdit && !!tags.all.length && managePrompt ? (
      <TagManagerPrompt
        label={managePrompt}
        onClick={() => openTagManagerCard()}
      />
    ) : null

  return (
    <>
      <TagSelector
        tags={tags}
        tagPermissions={tagPermissions}
        postMenuList={postMenuList}
        selectLabel={selectLabel}
        tagFormLabels={tagFormLabels}
        {...passProps}
      />
      {tagManagerCardStack}
    </>
  )
}

TagSelectorWithTagManager.displayName = "TagSelectorWithTagManager"

TagSelectorWithTagManager.propTypes = {
  context: tagAttachmentContextPropType,
  onSelectTags: PropTypes.func
}

export default TagSelectorWithTagManager
